// extracted by css-extract-rspack-plugin
export default {"borderTop":"AccordionListCell-module__borderTop___pqZlA","borderBottom":"AccordionListCell-module__borderBottom___MITAm","action":"AccordionListCell-module__action___DpEkY"};